import { SidebarElement } from "./types/sidebar";
import { createBrowserRouter } from "react-router-dom";
import { Router as RemixRouter } from "@remix-run/router/dist/router";
import Home from "src/pages/Home";
import LoginPage from "src/pages/Login";
import JoinPage from "src/pages/Join";
import NotFoundPage from "src/pages/404";
import CommonLayout from "src/layout/CommonLayout";
import ConsolePage from "src/pages/Console";
import SiteTypePage from "src/pages/Site/Type";
import AuthLayout from "src/layout/AuthLayout";
import SitePayPage from "src/pages/Site/Pay";
import SitePromotionPage from "src/pages/Site/Promotion";
import ConsoleBillPage from "src/pages/Console/Bill";
import MyAccountPage from "src/pages/Console/MyAccount";
import SiteTrialPage from "src/pages/Site/Trial";
import ExceptPayPal from "src/pages/Pay/PayPal";
import TermsCompPage from "src/pages/TermsComp";
import TermsPage from "src/pages/Terms";
import RouterErrorBoundary from "./RouterErrorBoundary";
import PayCard from "src/pages/Pay/Card";
import ExceptPayCard from "src/pages/Pay/ExceptCard";
import GuestPayCard from "src/pages/Pay/GuestCard";
import TermsV20260601Page from "src/pages/Terms/v20260601";
import PrivacyCompPage from "src/pages/PrivacyComp";
import ServiceListPage from "src/pages/Service/List";

interface RouterBase {
  id: number; // 페이지 아이디 (반복문용 고유값)
  path: string; // 페이지 경로
  label: string; // 사이드바에 표시할 페이지 이름
  element: React.ReactNode; // 페이지 엘리먼트
}

interface UserAccessibleRouterElement extends RouterBase {
  withAuth?: boolean; // 인증이 필요한 페이지 여부
}

interface AdminAccessibleRouterElement extends RouterBase {
  withAuth: true; // 인증이 필요한 페이지 여부
  isAdminPage?: boolean; // 어드민 페이지 여부
  isFooter?: boolean;
}

type RouterElement = UserAccessibleRouterElement | AdminAccessibleRouterElement;

const routerData: RouterElement[] = [
  {
    id: -4,
    path: "/except/paypal",
    label: "ExceptPayPal",
    element: <ExceptPayPal />,
    withAuth: true,
    // withAuth: false,
  },
  {
    id: -3,
    path: "/except/card",
    label: "ExceptPayCard",
    element: <ExceptPayCard />,
    withAuth: false,
    // withAuth: false,
  },
  {
    id: -5,
    path: "/pay/card/:promotionCode",
    label: "GuestPayCard",
    element: <GuestPayCard />,
    withAuth: false,
  },
  {
    id: -2,
    path: "/pay/card",
    label: "PayCard",
    element: <PayCard />,
    withAuth: false,
    // withAuth: false,
  },
  {
    id: -1,
    path: "/login/:uuid",
    label: "onceLogin",
    element: <LoginPage />,
    withAuth: false,
  },
  {
    id: -4,
    path: "/",
    label: "Home",
    element: <Home />,
    withAuth: false,
  },
  {
    id: 0,
    path: "/:lang/",
    label: "Home",
    element: <Home />,
    withAuth: false,
  },
  {
    id: 1,
    path: "/:lang/login",
    label: "Login",
    element: <LoginPage />,
    withAuth: false,
  },
  {
    id: 2,
    path: "/:lang/join",
    label: "Join",
    element: <JoinPage />,
    withAuth: false,
  },
  {
    id: 3,
    path: "/:lang/console",
    label: "Console",
    element: <ConsolePage />,
    withAuth: true,
    isAdminPage: true,
    isFooter: false,
  },
  {
    id: 4,
    path: "/:lang/site/type",
    label: "SiteType",
    element: <SiteTypePage />,
    withAuth: true,
    isFooter: false,
  },
  {
    id: 5,
    path: "/:lang/site/pay",
    label: "SitePay",
    element: <SitePayPage />,
    withAuth: true,
    isFooter: true,
  },
  {
    id: 6,
    path: "/:lang/site/trial",
    label: "SitePay",
    element: <SiteTrialPage />,
    withAuth: true,
    isFooter: true,
  },
  {
    id: 7,
    path: "/:lang/site/promotion",
    label: "SitePay",
    element: <SitePromotionPage />,
    withAuth: true,
    isFooter: true,
  },
  {
    id: 8,
    path: "/:lang/bill",
    label: "SitePay",
    element: <ConsoleBillPage />,
    withAuth: true,
    isAdminPage: true,
    isFooter: false,
  },
  {
    id: 9,
    path: "/:lang/my-account",
    label: "SitePay",
    element: <MyAccountPage />,
    withAuth: true,
    isAdminPage: true,
  },
  {
    id: 10,
    path: "/:lang/terms",
    label: "Terms",
    // element: <TermsPage />,
    element: <TermsV20260601Page />,
    withAuth: false,
  },
  {
    id: 10.1,
    path: "/:lang/terms/v20260601",
    label: "TermsV20260601",
    element: <TermsV20260601Page />,
    withAuth: false,
  },
  {
    id: 11,
    path: "/:lang/termsComp",
    label: "Terms",
    element: <TermsCompPage />,
    withAuth: false,
  },
  {
    id: 13,
    path: "/:lang/service/list",
    label: "ServiceList",
    element: <ServiceListPage />,
    withAuth: true,
    isFooter: true,
  },
  {
    id: 12,
    path: "/:lang/privacyComp",
    label: "PrivacyPolicy",
    element: <PrivacyCompPage />,
    withAuth: false,
  },
  {
    id: 9999,
    path: "*",
    label: "404",
    element: <NotFoundPage />,
    withAuth: false,
  },
  // {
  //   id: 3,
  //   path: "/page-b",
  //   label: "페이지 B",
  //   element: <PageB />,
  //   withAuth: true,
  // },
  // {
  //   id: 4,
  //   path: "/page-c",
  //   label: "페이지 C",
  //   element: <PageC />,
  //   withAuth: true,
  // },
  // // TODO 4-1: Admin페이지를 router에 추가
  // {
  //   id: 5,
  //   path: "/admin",
  //   label: "어드민 페이지",
  //   element: <AdminPage />,
  //   withAuth: true,
  //   isAdminPage: true,
  // },
];

export const routers: RemixRouter = createBrowserRouter(
  // TODO 4-1: 어드민 전용 페이지이거나 auth가 필요한 페이지는 AuthLayout 감싸기
  // 어드민 전용 페이지는 isAdminPage = true를 전달

  // ["ko", "en"].map((lang): any => {
  routerData.map((router) => {
    if (router.withAuth) {
      return {
        path: `${router.path}`,
        errorElement: <RouterErrorBoundary />,
        element: (
          <AuthLayout
            isAdminPage={"isAdminPage" in router && router.isAdminPage}
            isFooter={"isFooter" in router && router.isFooter}
          >
            {router.element}
          </AuthLayout>
        ),
      };
    } else {
      return {
        path: `${router.path}`,
        errorElement: <RouterErrorBoundary />,
        element: <CommonLayout>{router.element}</CommonLayout>,
      };
    }
  })
  // })
);

export const SidebarContent: SidebarElement[] = routerData.reduce(
  (prev, router) => {
    // TODO 4-1. isAdminOnly 프로퍼티를 추가하여 admin 페이지로 가는 사이드바 요소를 선택적으로 렌더링 (어드민에게만 보이도록 하기)
    if (!router.withAuth) return prev;

    return [
      ...prev,
      {
        id: router.id,
        path: `${router.path}`,
        label: router.label,
        isAdminOnly: "isAdminPage" in router && router.isAdminPage,
      },
    ];
  },
  [] as SidebarElement[]
);
